import type { IUser } from 'src/api/users-api';

export function getMessageSenderName(owner: number, currentUserId: number, teamMembers: IUser[]) {
    if (owner === currentUserId) {
        return 'You';
    }

    const teamMemberFistNameMap = new Map(
        teamMembers.map((member) => [
            member.id,
            member.name.split(' ')[0]
        ])
    );

    // If owner is not the current user, return the owner's first name
    return teamMemberFistNameMap.get(owner) || 'Unknown';
}
